import React from 'react';
import { Youtube, Music2, Instagram, ExternalLink } from 'lucide-react';

const YOUTUBE_URL = "https://youtube.com/@letsgetintoitfbe?si=lyzA8U32o3csvxTK";
const SPOTIFY_URL = "https://open.spotify.com/show/6B1NRfylqvaSDTedOPD3iz?si=RGWDLBCTQgOY7Hoh1b-mCg";
const INSTAGRAM_URL = "https://www.instagram.com/letsgetintoitfbe";
const TIKTOK_URL = "https://www.tiktok.com/@letsgetintoitfbe";

const TikTokIcon = () => (
  <svg width={18} height={18} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.87a8.16 8.16 0 0 0 4.76 1.52v-3.4a4.85 4.85 0 0 1-1-.3z"/>
  </svg>
);

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] border-t border-white/5 pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="font-heading text-2xl uppercase tracking-tight mb-3">LET'S GET IN TO IT</h3>
            <p className="font-body text-sm text-[#A1A1AA] leading-relaxed max-w-xs">
              Comedy about growing up and getting older. Streaming on Spotify & YouTube.
            </p>
          </div>

          <div>
            <h4 className="font-body text-xs tracking-[0.2em] uppercase font-bold text-[#FF2A2A] mb-4">QUICK LINKS</h4>
            <div className="space-y-2">
              <a href="/" data-testid="footer-home" className="block font-body text-sm text-[#A1A1AA] hover:text-white transition-colors">Home</a>
              <a href="/archive" data-testid="footer-episodes" className="block font-body text-sm text-[#A1A1AA] hover:text-white transition-colors">Episodes</a>
              <a href="/about" data-testid="footer-about" className="block font-body text-sm text-[#A1A1AA] hover:text-white transition-colors">About</a>
              <a href="/merch" data-testid="footer-merch" className="block font-body text-sm text-[#A1A1AA] hover:text-white transition-colors">Merch</a>
              <a href="/subscribe" className="block font-body text-sm text-[#A1A1AA] hover:text-white transition-colors">Subscribe</a>
            </div>
          </div>

          <div>
            <h4 className="font-body text-xs tracking-[0.2em] uppercase font-bold text-[#FF2A2A] mb-4">LISTEN & FOLLOW</h4>
            <div className="space-y-3">
              {[
                { url: YOUTUBE_URL, icon: <Youtube size={18} />, label: "YouTube", color: "text-[#FF2A2A]", testId: "footer-youtube-link" },
                { url: SPOTIFY_URL, icon: <Music2 size={18} />, label: "Spotify", color: "text-[#1DB954]", testId: "footer-spotify-link" },
                { url: INSTAGRAM_URL, icon: <Instagram size={18} />, label: "Instagram", color: "text-[#E1306C]", testId: "footer-instagram-link" },
                { url: TIKTOK_URL, icon: <TikTokIcon />, label: "TikTok", color: "text-[#00f2ea]", testId: "footer-tiktok-link" },
              ].map((s) => (
                <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" data-testid={s.testId}
                  className="flex items-center gap-3 text-[#A1A1AA] hover:text-white transition-colors group">
                  <span className={s.color}>{s.icon}</span>
                  <span className="font-body text-sm">{s.label}</span>
                  <ExternalLink size={12} className="opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="section-divider my-10" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-[#71717A]">&copy; 2026 Let's Get In To It. All rights reserved.</p>
          <p className="font-body text-xs text-[#71717A]">Now streaming on Spotify & YouTube</p>
        </div>
      </div>
    </footer>
  );
}
